(function () {
  'use strict';

  angular.module('bizmetryApp').component('bizJsonViewer', {

    bindings: {
      json:      '<',
      title:     '@',
      maxHeight: '@',
      query:     '<',   // optional — opens with this text already searched (e.g. a table search term)
      onClose:   '&'    // optional — when provided, a close button is shown in the header
    },

    templateUrl: '/common/components/biz-json-viewer/json-viewer.html',

    controller: ['$sce', '$timeout', function ($sce, $timeout) {
      var $ctrl = this;

      // ── State ─────────────────────────────────────────────────
      $ctrl.searchQuery  = '';
      $ctrl.matchCount   = 0;
      $ctrl.currentMatch = 0;
      $ctrl.copied       = false;
      $ctrl.renderedTree = null;
      $ctrl.bodyStyle    = {};

      var _parsedJson      = null;
      var _collapsedPaths  = {};
      var _currentMatchIdx = 0;
      var _searchDebounce  = null;

      // ── Lifecycle ─────────────────────────────────────────────
      $ctrl.$onInit = function () {
        _parseJson();
        _rebuild();

        if ($ctrl.maxHeight) {
          $ctrl.bodyStyle = { 'max-height': $ctrl.maxHeight };
        }

        if ($ctrl.query && String($ctrl.query).trim()) {
          $ctrl.searchQuery = String($ctrl.query).trim();
          $ctrl.onSearch();
        }

        window.bizJsonViewerToggle = function (el) {
          var path  = el.getAttribute('data-path');
          var scope = angular.element(el).scope();
          if (scope) {
            scope.$apply(function () {
              scope.$ctrl._togglePath(path);
            });
          }
        };
      };

      $ctrl.$onChanges = function (changes) {
        if (changes.json && !changes.json.isFirstChange()) {
          _parseJson();
          _collapsedPaths    = {};
          $ctrl.searchQuery  = '';
          $ctrl.matchCount   = 0;
          $ctrl.currentMatch = 0;
          _rebuild();
        }
        if (changes.maxHeight && changes.maxHeight.currentValue) {
          $ctrl.bodyStyle = { 'max-height': changes.maxHeight.currentValue };
        }
      };

      $ctrl.$onDestroy = function () {
        delete window.bizJsonViewerToggle;
        if (_searchDebounce) { $timeout.cancel(_searchDebounce); }
      };

      // ── Public actions ────────────────────────────────────────
      $ctrl._togglePath = function (path) {
        _collapsedPaths[path] = !_collapsedPaths[path];
        _rebuild();
      };

      $ctrl.expandAll = function () {
        _collapsedPaths = {};
        _rebuild();
      };

      $ctrl.collapseAll = function () {
        _collectCollapsiblePaths(_parsedJson, '$');
        _rebuild();
      };

      $ctrl.onSearch = function () {
        if (_searchDebounce) { $timeout.cancel(_searchDebounce); }
        _searchDebounce = $timeout(function () {
          $ctrl.currentMatch = 1;
          _rebuild();
          if ($ctrl.matchCount > 0) { _scrollToMatch(0); }
        }, 180);
      };

      $ctrl.onSearchKeydown = function ($event) {
        if ($event.key === 'Enter')  { $event.preventDefault(); $ctrl.nextMatch(); }
        if ($event.key === 'Escape') { $ctrl.clearSearch(); }
      };

      $ctrl.clearSearch = function () {
        $ctrl.searchQuery  = '';
        $ctrl.matchCount   = 0;
        $ctrl.currentMatch = 0;
        _rebuild();
      };

      $ctrl.nextMatch = function () {
        if ($ctrl.matchCount === 0) { return; }
        $ctrl.currentMatch = ($ctrl.currentMatch >= $ctrl.matchCount) ? 1 : $ctrl.currentMatch + 1;
        _updateActiveMatch();
      };

      $ctrl.prevMatch = function () {
        if ($ctrl.matchCount === 0) { return; }
        $ctrl.currentMatch = ($ctrl.currentMatch <= 1) ? $ctrl.matchCount : $ctrl.currentMatch - 1;
        _updateActiveMatch();
      };

      $ctrl.copyJson = function () {
        if (_parsedJson === null) { return; }
        var text = JSON.stringify(_parsedJson, null, 2);
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text)
            .then(function ()  { _flashCopied(); })
            .catch(function () { _fallbackCopy(text); });
        } else {
          _fallbackCopy(text);
        }
      };

      // ── JSON parsing ──────────────────────────────────────────
      function _parseJson() {
        var raw = $ctrl.json;
        try {
          if (typeof raw === 'string') {
            var parsed  = JSON.parse(raw);
            _parsedJson = (typeof parsed === 'string') ? JSON.parse(parsed) : parsed;
          } else if (raw !== null && raw !== undefined) {
            _parsedJson = raw;
          } else {
            _parsedJson = null;
          }
        } catch (e) {
          _parsedJson = null;
        }
      }

      // ── Tree rebuild ──────────────────────────────────────────
      function _rebuild() {
        if (_parsedJson === null || _parsedJson === undefined) {
          $ctrl.renderedTree = null;
          $ctrl.matchCount   = 0;
          return;
        }

        _currentMatchIdx = 0;
        var html         = _renderNode(_parsedJson, '$', 0);
        $ctrl.matchCount = _currentMatchIdx;

        if ($ctrl.currentMatch > $ctrl.matchCount) {
          $ctrl.currentMatch = $ctrl.matchCount > 0 ? 1 : 0;
        }
        if ($ctrl.matchCount > 0 && $ctrl.currentMatch === 0) {
          $ctrl.currentMatch = 1;
        }

        $ctrl.renderedTree = $sce.trustAsHtml(html);
      }

      // ── Rendering ─────────────────────────────────────────────
      function _renderNode(node, path, level) {
        if (node === null)             { return _primitive('null',                   'null'); }
        if (typeof node === 'boolean') { return _primitive(String(node),             'boolean'); }
        if (typeof node === 'number')  { return _primitive(String(node),             'number'); }
        if (typeof node === 'string')  { return _primitive('"' + _esc(node) + '"',   'string'); }
        if (Array.isArray(node))       { return _renderArray(node,  path, level); }
        if (typeof node === 'object')  { return _renderObject(node, path, level); }
        return _primitive(_esc(String(node)), 'string');
      }

      function _renderObject(obj, path, level) {
        var ind      = _ind(level);
        var indNext  = _ind(level + 1);
        var keys     = Object.keys(obj);
        var collapsed = !!_collapsedPaths[path] && !$ctrl.searchQuery.trim();
        var safePath  = _escAttr(path);
        var html      = '';

        if (keys.length > 0) {
          html += '<span class="bvw-toggle' + (collapsed ? ' collapsed' : '') + '" '
               +  'data-path="' + safePath + '" '
               +  'title="' + (collapsed ? 'Expand' : 'Collapse') + '" '
               +  'onclick="bizJsonViewerToggle(this)"></span>';
        } else {
          html += '<span class="bvw-toggle-spacer"></span>';
        }

        html += '<span class="bvw-bracket">{</span>';

        if (collapsed) {
          var kc = keys.length;
          html += '<span class="bvw-hint"> … ' + kc + (kc === 1 ? ' key' : ' keys') + ' </span>';
          html += '<span class="bvw-bracket">}</span>';
          return html;
        }

        if (keys.length === 0) {
          html += '<span class="bvw-bracket">}</span>';
          return html;
        }

        html += '\n';

        keys.forEach(function (key, i) {
          var value  = obj[key];
          var child  = path + '.' + key;
          var isLast = (i === keys.length - 1);

          html += indNext;
          html += '<span class="bvw-key">"' + _highlight(key) + '"</span><span class="bvw-colon">: </span>';

          if (value !== null && typeof value === 'object') {
            html += _renderNode(value, child, level + 1);
          } else {
            html += _renderNode(value, child, level);
          }

          if (!isLast) { html += '<span class="bvw-comma">,</span>'; }
          html += '\n';
        });

        html += ind + '<span class="bvw-toggle-spacer"></span><span class="bvw-bracket">}</span>';
        return html;
      }

      function _renderArray(arr, path, level) {
        var ind      = _ind(level);
        var indNext  = _ind(level + 1);
        var collapsed = !!_collapsedPaths[path] && !$ctrl.searchQuery.trim();
        var safePath  = _escAttr(path);
        var html      = '';

        if (arr.length > 0) {
          html += '<span class="bvw-toggle' + (collapsed ? ' collapsed' : '') + '" '
               +  'data-path="' + safePath + '" '
               +  'title="' + (collapsed ? 'Expand' : 'Collapse') + '" '
               +  'onclick="bizJsonViewerToggle(this)"></span>';
        } else {
          html += '<span class="bvw-toggle-spacer"></span>';
        }

        html += '<span class="bvw-bracket">[</span>';

        if (collapsed) {
          var ic = arr.length;
          html += '<span class="bvw-hint"> … ' + ic + (ic === 1 ? ' item' : ' items') + ' </span>';
          html += '<span class="bvw-bracket">]</span>';
          return html;
        }

        if (arr.length === 0) {
          html += '<span class="bvw-bracket">]</span>';
          return html;
        }

        html += '\n';

        arr.forEach(function (item, i) {
          var child  = path + '[' + i + ']';
          var isLast = (i === arr.length - 1);

          html += indNext;
          html += '<span class="bvw-index">[' + i + ']</span> ';

          if (item !== null && typeof item === 'object') {
            html += _renderNode(item, child, level + 1);
          } else {
            html += _renderNode(item, child, level);
          }

          if (!isLast) { html += '<span class="bvw-comma">,</span>'; }
          html += '\n';
        });

        html += ind + '<span class="bvw-toggle-spacer"></span><span class="bvw-bracket">]</span>';
        return html;
      }

      function _primitive(display, type) {
        return '<span class="bvw-value ' + type + '">' + _highlight(display) + '</span>';
      }

      // ── Search ────────────────────────────────────────────────
      function _highlight(rawText) {
        var text   = String(rawText);
        var q      = $ctrl.searchQuery ? $ctrl.searchQuery.trim() : '';

        if (!q) { return _esc(text); }

        var lower  = text.toLowerCase();
        var qLower = q.toLowerCase();
        var pos    = 0;
        var idx;
        var result = '';

        while ((idx = lower.indexOf(qLower, pos)) !== -1) {
          result += _esc(text.slice(pos, idx));
          var mIdx     = _currentMatchIdx;
          var isActive = (mIdx === $ctrl.currentMatch - 1);
          result += '<span class="bvw-match' + (isActive ? ' bvw-match-active' : '') + '" id="bvw-m-' + mIdx + '">';
          result += _esc(text.slice(idx, idx + q.length));
          result += '</span>';
          _currentMatchIdx++;
          pos = idx + q.length;
        }
        result += _esc(text.slice(pos));
        return result;
      }

      function _updateActiveMatch() {
        var all = document.querySelectorAll('.bvw-match');
        all.forEach(function (el, i) {
          el.classList.toggle('bvw-match-active', i === $ctrl.currentMatch - 1);
        });
        _scrollToMatch($ctrl.currentMatch - 1);
      }

      function _scrollToMatch(index) {
        $timeout(function () {
          var el = document.getElementById('bvw-m-' + index);
          if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        }, 30);
      }

      // ── Collapse helpers ──────────────────────────────────────
      function _collectCollapsiblePaths(node, path) {
        if (node === null || typeof node !== 'object') { return; }
        if ((Array.isArray(node) && node.length > 0) ||
            (!Array.isArray(node) && Object.keys(node).length > 0)) {
          _collapsedPaths[path] = true;
        }
        if (Array.isArray(node)) {
          node.forEach(function (item, i) {
            _collectCollapsiblePaths(item, path + '[' + i + ']');
          });
        } else {
          Object.keys(node).forEach(function (key) {
            _collectCollapsiblePaths(node[key], path + '.' + key);
          });
        }
      }

      // ── Copy helpers ──────────────────────────────────────────
      function _flashCopied() {
        $ctrl.copied = true;
        $timeout(function () { $ctrl.copied = false; }, 2000);
      }

      function _fallbackCopy(text) {
        var ta           = document.createElement('textarea');
        ta.value         = text;
        ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        _flashCopied();
      }

      // ── Utilities ─────────────────────────────────────────────
      function _ind(level) { return '  '.repeat(level); }

      function _esc(text) {
        return String(text).replace(/[&<>"']/g, function (ch) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[ch];
        });
      }

      function _escAttr(text) {
        return String(text)
          .replace(/&/g,  '&amp;')
          .replace(/"/g,  '&quot;');
      }

    }]
  });

}());